import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Component({
    selector: 'app-session-popup',
    templateUrl: './session-popup.component.html',
    styleUrls: ['./session-popup.component.css'],
    standalone: false
})

export class SessionPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SessionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject('LOCALSTORAGE') private localStorage: any,
  private router: Router
  ) {}

  ngOnInit(): void {
  }
  onClose(): void {
    console.log('this is close dialogue', this.localStorage);
    if (this.localStorage) {
      delete this.localStorage.access_token;
      delete this.localStorage.user_menu;
      delete this.localStorage.user_permissions;
      delete this.localStorage.current_account_id;
      delete this.localStorage.current_account_name;
      delete this.localStorage.current_user_email;
      delete this.localStorage.current_user_id;
      delete this.localStorage.current_user_name;
      delete this.localStorage.current_user_name_da_grymne;
    }
    this.dialogRef.close();
    this.router.navigate(['/forgot']);
  }
}
